/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { StripeControllerCreatePortalMutationRequest, StripeControllerCreatePortalMutationResponse, StripeControllerCreatePortalQueryParams, StripeControllerCreatePortal400, StripeControllerCreatePortal401, StripeControllerCreatePortal403, StripeControllerCreatePortal404, StripeControllerCreatePortal409, StripeControllerCreatePortal500 } from "../types/StripeControllerCreatePortal.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getStripeControllerCreatePortalUrl() {
  const res = { method: 'POST', url: `/api/stripe/portal` as const }
  return res
}

/**
 * @description Creates a Stripe Billing Portal session for the organisation admin. The portal lets the admin manage subscriptions, add/remove seats, and update billing details. Returns the portal URL to redirect the admin to.
 * @summary Create Billing Portal Session
 * {@link /api/stripe/portal}
 */
export async function stripeControllerCreatePortal(data: StripeControllerCreatePortalMutationRequest, params?: StripeControllerCreatePortalQueryParams, config: Partial<RequestConfig<StripeControllerCreatePortalMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<StripeControllerCreatePortalMutationResponse, ResponseErrorConfig<StripeControllerCreatePortal400 | StripeControllerCreatePortal401 | StripeControllerCreatePortal403 | StripeControllerCreatePortal404 | StripeControllerCreatePortal409 | StripeControllerCreatePortal500>, StripeControllerCreatePortalMutationRequest>({ method : "POST", url : getStripeControllerCreatePortalUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}